// extracted by mini-css-extract-plugin
module.exports = {"itemBottonBlock__link":"SimpleButtonList_itemBottonBlock__link__3R_LN","itemBottonBlock__link__robotIcon":"SimpleButtonList_itemBottonBlock__link__robotIcon__27-H1"};